var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44767 0.394086C7.62152 -0.131362 8.37848 -0.131362 8.55233 0.394086L10.0427 4.89873C10.1205 5.13371 10.3435 5.29281 10.5951 5.29281H15.4181C15.9807 5.29281 16.2146 5.9998 15.7595 6.32454L11.8576 9.10856C11.654 9.25379 11.5688 9.51122 11.6466 9.74621L13.137 14.2508C13.3108 14.7763 12.6984 15.2132 12.2433 14.8885L8.34136 12.1045C8.13781 11.9592 7.86219 11.9592 7.65864 12.1045L3.7567 14.8885C3.30156 15.2132 2.68916 14.7763 2.86301 14.2508L4.35342 9.74621C4.43117 9.51122 4.346 9.25379 4.14245 9.10856L0.240509 6.32454C-0.214637 5.9998 0.0192781 5.29281 0.581869 5.29281H5.40493C5.65653 5.29281 5.87951 5.13371 5.95726 4.89873L7.44767 0.394086Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.7ac3cc0b9d33db39adb20556b39f326e.svg";
export { ForwardRef as ReactComponent };